import React from "react";
import { AlertTriangle, CheckCircle2, Timer, MousePointerClick, Eye, Trophy } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const RULES = [
  { icon: MousePointerClick, text: "Answers are FINAL — once selected, an answer cannot be changed." },
  { icon: Timer, text: "Every question has its own server-side timer. When it hits zero, the question is auto-marked unanswered." },
  { icon: Eye, text: "Tab switches, minimizes and copy attempts are recorded by the anti-cheat system." },
  { icon: Trophy, text: "Score = correctness + speed bonus. Faster correct answers earn more points." },
];

export default function QuizRulesModal({ open, onAccept, onCancel }) {
  return (
    <Dialog open={open}>
      <DialogContent
        data-testid="quiz-rules-modal"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="max-w-md [&>button]:hidden"
      >
        <div className="tricolor-bar h-1.5 rounded-full" />
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-black tracking-tight flex items-center gap-2 text-slate-900">
            <AlertTriangle className="w-6 h-6 text-[#FF9933]" /> Before You Begin
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-2.5 mt-1">
          {RULES.map((r, i) => (
            <div key={i} className="flex items-start gap-3 bg-slate-50 border border-slate-100 rounded-lg px-4 py-3">
              <r.icon className="w-4 h-4 text-[#003366] mt-0.5 shrink-0" />
              <span className="text-sm text-slate-600 font-medium">{r.text}</span>
            </div>
          ))}
        </div>
        <div className="flex gap-3 mt-4">
          <button onClick={onCancel} data-testid="rules-cancel" className="flex-1 py-3 rounded-lg border-2 border-slate-300 text-slate-600 font-bold hover:border-slate-500 transition-colors">
            Back
          </button>
          <button onClick={onAccept} data-testid="rules-accept" className="flex-1 py-3 rounded-lg bg-[#138808] text-white font-bold hover:bg-[#0f6d06] transition-colors inline-flex items-center justify-center gap-2">
            <CheckCircle2 className="w-4 h-4" /> I Understand — Start
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
